import type { I18nMessage } from "@pollen/core/model/i18n.model";

export const BRAND_KEY_FIGURES = [
  {
    id: "learners",
    value: "+50K",
    label: "Talents formés",
  },
  {
    id: "rating",
    value: "4.9/5",
    label: "de satisfaction moyenne",
  },
  {
    id: "trainers",
    value: "+600",
    label: "experts en poste",
  },
] satisfies { id: string; label: I18nMessage; value: string }[];
